import { IModalChangePropsReducer, IModalOpenReducer } from './ModalsReducer';

export const MODAL_ACTIONS_OPEN = 'MODAL_ACTIONS_OPEN';
export const MODAL_ACTIONS_CHANGE_PROPS = 'MODAL_ACTIONS_CHANGE_PROPS';
export const MODAL_ACTIONS_CLOSE = 'MODAL_ACTIONS_CLOSE';
export const MODAL_ACTIONS_CLEAR = 'MODAL_ACTIONS_CLEAR';

export interface ModalsActionsOpen {
  type: typeof MODAL_ACTIONS_OPEN;
  payload: IModalOpenReducer;
}

export interface ModalsActionsChangeProps {
  type: typeof MODAL_ACTIONS_CHANGE_PROPS;
  payload: IModalChangePropsReducer;
}

export interface ModalsActionsClose {
  type: typeof MODAL_ACTIONS_CLOSE;
  payload: string;
}
export interface ModalsActionsClear {
  type: typeof MODAL_ACTIONS_CLEAR;
  payload: string;
}

export type ModalsActionTypes =
  | ModalsActionsOpen
  | ModalsActionsChangeProps
  | ModalsActionsClose
  | ModalsActionsClear;
